module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_waso_yoso@2x-ca9620aed8f7ff14cee03f8dae3a8cb2.webp";